export default {"src":"/_next/static/media/apple-podcasts.2396bc0e.svg","height":41,"width":129,"blurWidth":0,"blurHeight":0};